export const DATA_ORIGIN = 'https://ebc-portal-2024.com';

export const dataFileUrl = (path: string): string | undefined => {
  if (!path.startsWith('/app/')) return undefined;
  if (path.includes('..') || path.includes('@') || path.includes('://') || path.includes('\\')) {
    return undefined;
  }
  return `${DATA_ORIGIN}${path}`;
};
